import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import IconUpgrade from '@src/assets/images/icon-paid-package.png';
import { PACKAGE_LEVEL_V3, PACKAGE_TYPE } from '@src/constants/package';
import { LINK_GUIDE_NOT_ENOUGH_CREDITS } from '@src/constants/tts';
import { useMappingPackage } from '@src/hooks/useMappingPackage';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import { MOE_PAYWALL_CTA, MOE_PAYWALL_TYPE } from '@src/constants/moengage';

const OutOfCreditsVip = ({ open, onClose, warningOneTimeCredits }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { packages } = useMappingPackage();
  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.OUT_OF_CREDITS,
  });

  const handleBuyMore = () => {
    const topupPackageCode = packages.find(
      (p) =>
        p.type === PACKAGE_TYPE.STUDIO &&
        p.level === PACKAGE_LEVEL_V3.VIP &&
        p.isTopUp,
    )?.code;
    trackCta(MOE_PAYWALL_CTA.TOPUP, { targetPackageCode: topupPackageCode });
    const url = `${ROUTES.PAYMENT}?package=${topupPackageCode}`;
    history.push(url);
  };

  const renderBuyMoreButton = () => (
    <Button variant="contained" onClick={handleBuyMore}>
      {t('buyMoreChar')}
    </Button>
  );

  const warning = warningOneTimeCredits
    ? t('warningOnetimeCreditsWithVipPkg', {
        link: LINK_GUIDE_NOT_ENOUGH_CREDITS,
      })
    : '';

  return (
    <NotificationDialogV4
      image={IconUpgrade}
      title={t('outOfCredits')}
      description={t('descriptionOutOfCreditsVip', {
        warning,
      })}
      actionComponent={renderBuyMoreButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default OutOfCreditsVip;
